var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2692 26.4299C31.0852 24.5839 29.8329 21.8857 29.8329 19.0271V15C29.8329 9.917 26.0571 5.70933 21.1662 5.00444V3.44444C21.1662 2.64566 20.5191 2 19.7218 2C18.9245 2 18.2773 2.64566 18.2773 3.44444V5.00444C13.385 5.70933 9.61068 9.917 9.61068 15V19.0271C9.61068 21.8857 8.35834 24.5839 6.16134 26.4414C5.59945 26.9224 5.27734 27.6216 5.27734 28.3611C5.27734 29.755 6.41123 30.8889 7.80512 30.8889H31.6385C33.0323 30.8889 34.1662 29.755 34.1662 28.3611C34.1662 27.6216 33.8441 26.9224 33.2692 26.4299Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.721 36.6667C22.3368 36.6667 24.5252 34.8019 25.0278 32.3333H14.4141C14.9167 34.8019 17.1051 36.6667 19.721 36.6667Z",
    fill: "black"
  })));
};
export default SvgBell;